<template>
    <table class="table">
        <tbody>
        <tr>
            <td>Имя:</td>
            <td><span>{{data.name}}</span></td>
        </tr>
        <tr>
            <td>Логин:</td>
            <td><span>{{data.login}}</span></td>
        </tr>
        <tr>
            <td>Пароль:</td>
            <td><span>{{data.password}}</span></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "UserRegisterParams",
    props: {
        data: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
